export const defaultTriggers = {
  fr: [
    'Eau',
    'Feu',
    'Arbre',
    'Animal',
    'Maison',
    'École',
    'Hôpital',
    'Marché',
    'Voiture',
    'Téléphone',
    'Chaussures',
    'Sac',
    'Livre',
    'Route',
    'Lumière',
    'Fête',
    'Musique',
    'Sport',
    'Maman',
    'Enfant',
    'Travail',
    'Sommeil',
    'Fruit',
    'Légume',
    'Jardin',
    'Graines',
    'Électricité',
    'Plastique',
    'Énergie',
    'Outil'
  ],
  en: [
    'Water',
    'Fire',
    'Tree',
    'Animal',
    'House',
    'School',
    'Hospital',
    'Market',
    'Car',
    'Phone',
    'Shoes',
    'Bag',
    'Book',
    'Road',
    'Light',
    'Party',
    'Music',
    'Sport',
    'Mother',
    'Child',
    'Work',
    'Sleep',
    'Fruit',
    'Vegetable',
    'Garden',
    'Seeds',
    'Electricity',
    'Plastic',
    'Energy',
    'Tool'
  ],
  ar: [
    'ماء',
    'نار',
    'شجرة',
    'حيوان',
    'منزل',
    'مدرسة',
    'مستشفى',
    'سوق',
    'سيارة',
    'هاتف',
    'حذاء',
    'حقيبة',
    'كتاب',
    'طريق',
    'ضوء',
    'حفلة',
    'موسيقى',
    'رياضة',
    'أم',
    'طفل',
    'عمل',
    'نوم',
    'فاكهة',
    'خضار',
    'حديقة',
    'بذور',
    'كهرباء',
    'بلاستيك',
    'طاقة',
    'أداة'
  ]
};

export const defaultCategories = {
  fr: [
    'Service',
    'Produit',
    'Artisanat',
    'Agriculture',
    'Technologie de l\'information',
    'Mix 2 (2 categories au choix)',
    'Mix 4 (4 categories au choix)'
  ],
  en: [
    'Service',
    'Product',
    'Crafts',
    'Agriculture',
    'Information Technology',
    'Mix 2 (2 categories of choice)',
    'Mix 4 (4 categories of choice)'
  ],
  ar: [
    'خدمة',
    'منتج',
    'حرف يدوية',
    'زراعة',
    'تكنولوجيا المعلومات',
    'مزيج 2 (فئتان من اختيارك)',
    'مزيج 4 (4 فئات من اختيارك)'
  ]
}; 
